import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { nreumPageAction } from "../utils/perfTelemetry";

/**
 * Emits New Relic page actions for SPA route transitions (pathname only).
 */
export default function RouteTransitionTracker() {
  const location = useLocation();
  const previousPath = useRef<string | null>(null);
  const startedAt = useRef(performance.now());

  useEffect(() => {
    const path = location.pathname;
    const duration_ms = Math.round(performance.now() - startedAt.current);
    const from = previousPath.current;
    previousPath.current = path;
    startedAt.current = performance.now();

    if (!from || from === path) return;

    nreumPageAction("RouteTransition", {
      from,
      to: path,
      duration_ms,
    });
  }, [location.pathname]);

  return null;
}
